import { Button, CircularProgress, SxProps } from "@mui/material";
import { Theme } from "@emotion/react";
import {
  COLOR_LIGHT_GRAY,
  COLOR_MAIN,
  COLOR_WHITE,
} from "../../data/colors/Colors";
import { CustomTextView } from "./CustomTextView";

interface props {
  text: string | undefined;
  fontWeight?: string;
  fontSize?:
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "subtitle1"
    | "subtitle2"
    | "body1"
    | "body2"
    | "caption"
    | "button"
    | "overline";
  textColor?: string;
  backgroundColor?: string;
  type?: "submit" | "button";
  onClick?: (e: React.MouseEvent<HTMLButtonElement | Element>) => void;
  props?: SxProps<Theme>;
  elevation?: number;
  disabled?: boolean;
  height?: string;
  isGlowing?: boolean;
  glowingColor?: string;
  loading?: boolean;
}

export const CustomButtonView: React.FC<props> = ({
  text,
  fontWeight = "bold",
  fontSize = "body1",
  textColor = COLOR_WHITE,
  backgroundColor = COLOR_MAIN,
  type = "button",
  onClick,
  disabled = false,
  elevation,
  loading = false,
  height,
  glowingColor,
  isGlowing = false,
  props,
}: props) => {
  return (
    <Button
      type={type}
      sx={{
        background: disabled || loading ? "darkGray" : backgroundColor,
        borderRadius: 12,
        "&:hover": {
          background: COLOR_LIGHT_GRAY,
          "@media (hover: none)": {
            backgroundColor: backgroundColor,
          },
        },
        "@keyframes glowing": {
          "0%": {
            backgroundColor: backgroundColor,
            boxShadow: "0 0 5px " + backgroundColor,
          },
          "50%": {
            backgroundColor: glowingColor,
            boxShadow: "0 0 25px " + glowingColor,
          },
          "100%": {
            backgroundColor: backgroundColor,
            boxShadow: "0 0 5px " + backgroundColor,
          },
        },
        animation: isGlowing ? "glowing 1300ms infinite" : undefined,
        boxShadow: elevation ?? undefined,
        height,
      }}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <CircularProgress sx={{ color: COLOR_MAIN }} size={24} />
      ) : (
        <CustomTextView
          variant={fontSize}
          text={text}
          props={{ textTransform: "none", ...props }}
          textColor={disabled || loading ? "lightGray" : textColor}
          fontWeight={disabled || loading ? "normal" : fontWeight}
          textAlign="center"
        />
      )}
    </Button>
  );
};
